import { IMAGES } from "../assets/images";
import {
  ProductCategory,
  ProductionLine,
  CompanyStats,
  TeamMember,
  DownloadItem,
  ROUTE_PATHS,
} from "../lib/index";

/**
 * Ekstrüzyon hatları verileri (4", 5", 6", 7")
 */
export const productionLines: ProductionLine[] = [
  {
    id: "line-4",
    title: "4 Inç Ekstrüzyon Hattı",
    capacity: "2400 Ton/Yıl",
    description: "Yüksek hassasiyet gerektiren küçük ve orta ölçekli profil üretimi için optimize edilmiştir.",
    image: "/images/Gemini_Generated_Image_wl5sy6wl5sy6wl5s.png",
    type: "extrusion",
    specifications: [
      "Minimum et kalınlığı: 0.8 mm",
      "Maksimum profil genişliği: 110 mm",
      "Otomatik kesim ve soğutma sistemi",
      "Hassas tolerans kontrolü",
    ],
  },
  {
    id: "line-5",
    title: "5 Inç Ekstrüzyon Hattı",
    capacity: "3600 Ton/Yıl",
    description: "Esnek üretim kapasitesi ile standart mimari profillerin hızlı çevrim sürelerinde üretilmesini sağlar.",
    image: "/images/indir (1).jpg",
    type: "extrusion",
    specifications: [
      "Minimum et kalınlığı: 1.0 mm",
      "Maksimum profil genişliği: 140 mm",
      "PLC kontrollü işlem yönetimi",
      "Hızlı kalıp değiştirme sistemi",
    ],
  },
  {
    id: "line-6",
    title: "6 Inç Ekstrüzyon Hattı",
    capacity: "5400 Ton/Yıl",
    description: "Endüstriyel profiller ve geniş yüzeyli mimari sistemler için yüksek verimlilik sunan ana üretim hattımız.",
    image: "/images/Ekran görüntüsü 2026-02-07 202330.png",
    type: "extrusion",
    specifications: [
      "Minimum et kalınlığı: 1.2 mm",
      "Maksimum profil genişliği: 180 mm",
      "Yüksek hızlı çekici sistemi",
      "Gelişmiş termal yönetim",
    ],
  },
  {
    id: "line-7",
    title: "7 Inç Ekstrüzyon Hattı",
    capacity: "7200 Ton/Yıl",
    description: "Büyük ölçekli yapısal bileşenler ve ağır sanayi profilleri için tasarlanmış yüksek basınçlı hat.",
    image: "/images/Ekran görüntüsü 2026-02-07 202330.png",
    type: "extrusion",
    specifications: [
      "Minimum et kalınlığı: 1.5 mm",
      "Maksimum profil genişliği: 220 mm",
      "Çift çekici (Double puller) teknolojisi",
      "Otomatik istifleme ünitesi",
    ],
  },
];

/**
 * Toz boyama tesisleri (2 Yatay, 1 Dikey)
 */
export const coatingFacilities: ProductionLine[] = [
  {
    id: "coating-h1",
    title: "Yatay Toz Boya Hattı 1",
    capacity: "4.500 Ton/Yıl",
    description: "Standart RAL renkleri ve özel dokulu yüzeyler için yüksek kapasiteli konveyör sistemi.",
    image: "/images/boyahane-konveyor-sistemleri-ZHjL0tvuMw2uLU89TL8u.jpg",
    type: "coating",
    specifications: [
      "Maksimum profil boyu: 7.5 metre",
      "Hızlı renk değişim kabini",
      "Qualicoat standartlarına tam uyum",
      "Otomatik yüzey hazırlama (Chrome-free)",
    ],
  },
  {
    id: "coating-h2",
    title: "Yatay Toz Boya Hattı 2",
    capacity: "4.500 Ton/Yıl",
    description: "Yüksek adetli seri üretimler için optimize edilmiş, enerji verimliliği yüksek boyama hattı.",
    image: "/images/görsel_2026-02-09_111820137.png",
    type: "coating",
    specifications: [
      "Enerji tasarruflu fırınlama sistemi",
      "Gelişmiş elektrostatik tabanca grubu",
      "Hassas kalınlık kontrolü",
      "Sürekli hat takibi (SCADA)",
    ],
  },
  {
    id: "coating-v1",
    title: "Dikey Toz Boya Hattı",
    capacity: "12.000 Ton/Yıl",
    description: "Üstün yüzey kalitesi ve maksimum verimlilik için tasarlanmış modern dikey tesis.",
    image: "/images/görsel_2026-02-09_110457202.png",
    type: "coating",
    specifications: [
      "Kesintisiz askılama ve boyama süreci",
      "360 derece homojen boya dağılımı",
      "Minimum fire ve maksimum hız",
      "Tam otomatik kimyasal dozajlama",
    ],
  },
];

/**
 * Ürün kategorileri
 */
export const productCategories: ProductCategory[] = [
  {
    id: "architectural",
    title: "Mimari Sistemler",
    description: "Modern yapılar için estetik, dayanıklı ve yüksek yalıtımlı alüminyum çözümleri.",
    image: IMAGES.OFFICE_PART_300,
    path: ROUTE_PATHS.PRODUCTS_ARCHITECTURAL,
    features: [
      "Isı Yalıtımlı Kapı ve Pencere Sistemleri",
      "Giydirme Cephe Sistemleri",
      "Sürme ve Katlanır Kapı Sistemleri",
      "Ofis Bölme Sistemleri",
    ],
  },
  {
    id: "facade",
    title: "Cephe ve Doğrama Sistemleri",
    description: "Modern mimarinin ihtiyaçlarına uygun, estetik ve fonksiyonel cephe çözümleri.",
    image: IMAGES.ALUMINUM_PRODUCTS_3,
    path: ROUTE_PATHS.FACADE_SYSTEMS,
    features: [
      "İleri Teknoloji Giydirme Cephe Sistemleri",
      "Yapısal Glazing Sistemleri",
      "Perde Duvar Sistemleri",
      "Kompozit Panel Sistemleri",
    ],
  },
  {
    id: "industrial",
    title: "Endüstriyel Profiller",
    description: "Otomotivden enerjiye, beyaz eşyadan makine imalatına kadar her sektöre özel teknik profiller.",
    image: IMAGES.G_NE_ENERJISI_306,
    path: ROUTE_PATHS.PRODUCTS_INDUSTRIAL,
    features: [
      "Güneş Enerjisi (Solar) Paneli Profilleri",
      "Otomotiv ve Taşıma Sektörü Profilleri",
      "Makine ve Şasi Profilleri",
      "ısı Emiciler (Heatsinks)",
    ],
  },
];

/**
 * Kurumsal istatistikler
 */
export const companyStats: CompanyStats[] = [
  {
    id: "stat-1",
    label: "Yıllık Üretim Kapasitesi",
    value: "27.000",
    suffix: "Ton",
    description: "Entegre tesislerimizde gerçekleştirilen toplam ekstrüzyon hacmi.",
  },
  {
    id: "stat-2",
    label: "İhracat Yapılan Ülke",
    value: "45",
    suffix: "+",
    description: "Avrupa başta olmak üzere 5 kıtada global varlık.",
  },
  {
    id: "stat-3",
    label: "Uzman Çalışan",
    value: "150",
    suffix: "+",
    description: "Mühendislik ve üretim kadromuzla güçlüyüz.",
  },
  {
    id: "stat-4",
    label: "Toplam Kapalı Alan",
    value: "26.000",
    suffix: "m²",
    description: "Modern makine parkuruyla donatılmış üretim sahası.",
  },
];

/**
 * Yönetim ekibi
 */
export const teamMembers: TeamMember[] = [
  {
    id: "team-1",
    name: "Ahmet Yılmaz",
    role: "Yönetim Kurulu Başkanı",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: "team-2",
    name: "Mehmet Demir",
    role: "Genel Müdür",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=400",
  },
  {
    id: "team-3",
    name: "Selin Aksoy",
    role: "Üretim Direktörü",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=400",
  },
];

/**
 * İndirme Merkezi belgeleri
 */
export const downloadItems: DownloadItem[] = [
  {
    id: "cat-2026",
    title: "2026 Genel Ürün Kataloğu",
    category: "katalog",
    fileSize: "24.5 MB",
    updatedAt: "01.02.2026",
    url: "#",
  },
  {
    id: "tech-arch",
    title: "Mimari Sistemler Teknik Detay Föyü",
    category: "teknik",
    fileSize: "12.8 MB",
    updatedAt: "15.01.2026",
    url: "#",
  },
  {
    id: "cert-iso",
    title: "ISO 9001:2015 Kalite Sertifikası",
    category: "sertifika",
    fileSize: "1.2 MB",
    updatedAt: "10.12.2025",
    url: "#",
  },
];
